import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Steuernummer/USt-IdNr aus `appSettings/receipts.company` (öffentlich
 * lesbar, kein Auth nötig). Gepflegt über den Quittungs-Assistenten in den
 * Einstellungen — dadurch gibt es genau eine Quelle für die Nummer und sie
 * erscheint ohne Release in allen Impressum-Ansichten (nextcab_mobile:
 * docs/general/quittungsversand_konzept.md, Abschnitt 5).
 */
const useCompanyTaxId = () => {
  const [taxId, setTaxId] = useState({ vatId: null, taxNumber: null });

  useEffect(() => {
    let active = true;
    getDoc(doc(db, 'appSettings', 'receipts'))
      .then((snapshot) => {
        if (!active || !snapshot.exists()) return;
        const company = snapshot.data().company || {};
        setTaxId({
          vatId: company.vatId || null,
          taxNumber: company.taxNumber || null
        });
      })
      .catch(() => {
        // Ohne Firestore-Zugriff bleibt der Platzhaltertext stehen.
      });
    return () => {
      active = false;
    };
  }, []);

  return taxId;
};

export default useCompanyTaxId;
